import axes from './axes';
import internal from './internal';
import leaves from './leaves';
import dendrogram from './dendrogram';

export default Object.assign({},
    dendrogram,
    internal,
    leaves,
    axes
);


// WEBPACK FOOTER //
// ./src/graphics/index.js